export enum NOTIF_TYPES {
  REPORT = 'REPORT',
  PORTFOLIO_PROCESSING = 'PORTFOLIO_PROCESSING',
  PROCESS_LOG = 'PROCESS_LOG',
  HOLDER_DOWNLOAD = 'HOLDER_DOWNLOAD',
  RELEASE_NOTES = 'RELEASE_NOTES',
  CONTRACT_NOTES = 'CONTRACT_NOTES',
  IMPORT_FILE = 'IMPORT_FILE',
  UNMAPPED_DOC_COUNT = 'UNMAPPED_DOC_COUNT'
}
